import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from "./Loading";

import { withRouter } from "react-router-dom";

import { translate } from "../translate";


import API from "../api";

import imgBG from "../../assets/images/bg-full.jpg";


class FormLogin extends Component {

    constructor( props ) {
        super( props );
        this.state = {
            errors: [],
            loading: false,
            email: '',
            senha: '',
            remember: true,
            expire_date: this.addDate( new Date(), 7 )
        };

        API.setImageBackground( imgBG );
    };


    setEmail = ( v ) => this.setState( { email: v } );
    setPassword = ( v ) => this.setState( { senha: v } );
    setRemember = ( v ) => this.setState( { remember: v } );

    addDate = ( date, days ) => {
        // eslint-disable-next-line
        var date = date || new Date();
        date.setDate( date.getDate() + days );
        // eslint-disable-next-line
        date = date.toISOString().match( /(^[0-9]{4}\-[0-9]{2}\-[0-9]{2})/ )[0] + " 00:00:00";
        return date;
    }
    componentDidMount() {
        window.localStorage.clear();

    }



    login( e ) {
        const { email, senha, expire_date, remember } = this.state;
        if ( email && senha && expire_date ) {
            this.setState( { errors: [], loading: true } );

            API.post( "/login", {
                email: email, senha: senha, expire_date: expire_date
            } ).then( r => {
                if ( r.status === 200 && r.data ) {

                    let d = {
                        id: r.data.id,
                        name: r.data.nome,
                        remember: remember,
                        type: "Basic",
                        //TODO Remover usuario root que esta como padrao
                        token: btoa( r.data.email + ":" + r.data.senha )
                    }

                    this.setState( { loading: false } );


                    this.props.dispatch( { type: 'SET_CURRENT_USER', payload: d } );


                    if ( window.location.search.indexOf( "url_return" ) > -1 ) {
                        window.location.href = window.location.search.split( "url_return=" )[1];
                    }
                    else {
                        window.location.href = "/relatorios"; // Melhor para esse caso
                        //this.props.history.push( "/relatorios" );

                    }


                }
            }, error => {
                const msg = [{ "type": "alert-danger", "msg": "E-mail ou Senha estão inválidos" }];
                this.setState( { errors: msg, loading: false } )
            } );
        }

    }

    render() {

        const { email, senha, errors } = this.state;

        return (
            <form >
                <div className="form-group">
                    <label htmlFor="email">{translate( "login.email", "Email" )}:</label>
                    <input type="email" placeholder={translate( "login.email", "Email" )} defaultValue={email} className="form-control" id="email" onChange={e => this.setEmail( e.target.value )} />
                </div>
                <div className="form-group">
                    <label htmlFor="pwd">{translate( "login.senha", "Senha" )}:</label>
                    <input type="password" placeholder={translate( "login.senha", "Senha" )} defaultValue={senha} className="form-control" id="pwd" onChange={e => this.setPassword( e.target.value )} />
                </div>
                <br />
                {/* <div className="checkbox">
                    <label><input checked type="checkbox"  onChange={e => this.setRemember(e.target.value)} /> {translate("login.lembrar_me","Lembrar-me")} </label>
                </div> */}
                <button type="button" disabled={this.state.loading} className="btn btn-group-justified btn1" onClick={e => this.login( e )} >
                    {translate( "Login", "Login" )} <div style={{ display: "inline-block" }}><Loading hide={!!!this.state.loading} /></div>
                </button>
                {
                    errors.map( ( error, index ) => {
                        return (
                            <div key={index} className={`alert ${error.type || 'alert-danger'} mt-20`}>
                                <b> <i className="glyphicon glyphicon-alert"></i>  {translate( error.msg )} </b>
                            </div>
                        );
                    } )
                }



            </form>
        )
    }


}

// Get actions and pass them as props to to UserList
//      > now UserList has this.props.selectUser
function matchDispatchToProps( dispatch ) {
    return {
        dispatch,
        //...bindActionCreators({selectUser: selectUser}, dispatch)
    };
}

// "state" is set in reducers/index.js
function mapStateToProps( state ) {
    return {
        activeUser: state.activeUser
        //user: state.user
    };
}

export default withRouter( connect( mapStateToProps, matchDispatchToProps )( FormLogin ) );